import * as React from "react";
const SvgCheckmark = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M3 15L9.29412 20L21 4", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "square" }));
export default SvgCheckmark;
